// Identifies the domain resources touched by organization events, including
// resources carried as relationships instead of the event's primary subject.

import { type OrganizationEvent } from '@apps/web/hooks/use_organization_events';

export function organizationEventReferencesResource(
    event: OrganizationEvent,
    resourceType: OrganizationEvent['resource']['type'],
): boolean {
    return (
        event.resource.type === resourceType ||
        event.relationships.some(
            (relationship) => relationship.type === resourceType,
        )
    );
}

// v3 publishes these events against an `outreach` resource while v2 still
// publishes `callout`, so both spellings have to repaint.
export function organizationEventReferencesOutreach(
    event: OrganizationEvent,
    outreachId: string,
): boolean {
    return [event.resource, ...event.relationships].some(
        (resource) =>
            (resource.type === 'outreach' || resource.type === 'callout') &&
            resource.id === outreachId,
    );
}
